import styled from "styled-components";

// HEADER CSS Style
export const HeaderContainer = styled.div<{
    isPrm: boolean;
}>`
    height: ${(props) => (props.isPrm ? "12rem" : "15rem")};
    width: 95%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
    color: black;
    padding: 1.5rem 0rem;
`;

export const Separator = styled.div`
    background-color: #00ff07;
    height: 1rem;
`;

export const GreetingSectionContainer = styled.span<{
    isPrm: boolean;
}>`
    font-size: var(--font-size-title);
    font-weight: 700;
    grid-column: ${(props) => (props.isPrm ? "1 / 5" : "1 / 4")};
    text-align: ${(props) => (props.isPrm ? "center" : "start")};
    grid-row: 1;
    margin-top: 1rem;
`;
export const AuthenticateButtonContainer = styled.button<{
    inputColor: string;
}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    font-size: 1.5rem;
    background-color: var(--secondary-color);
    border-color: var(--secondary-color);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    margin-top: 1rem;
    border-radius: 12px;
    color: ${(props) => props.inputColor || "white"};
    width: 18rem;
    text-align: center;
    height: 4rem;
    grid-column: 4 / 4;
    grid-row: 1;
    justify-self: end;
`;
export const LoyaltyBalanceContainer = styled.div<{
    isPrm: boolean;
}>`
    font-weight: 400;
    letter-spacing: 2px;
    grid-column: ${(props) => (props.isPrm ? "1 / 5" : "1 / 4")};
    text-align: ${(props) => (props.isPrm ? "center" : "start")};
    grid-row: 2;
    font-size: var(--font-size-title);
`;
export const PromoCodeScanContainer = styled.button<{
    inputColor: string;
}>`
    grid-column: 4 / 4;
    grid-row: 2;
    color: ${(props) => props.inputColor || "black"};
    background-color: var(--global-color);
    border-color: var(--global-color);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    text-align: center;
    border-radius: 12px;
    width: 26rem;
    height: 4rem;
    display: flex;
    flex-wrap: row wrap;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    font-size: 1.2rem;
    font-weight: 500;
`;

// Promo Section CSS Style
export const PromoSectionContainer = styled.div`
    display: grid;
    grid-template-columns: 50% 20% 20%;
    gap: 30px;
    background-color: #00ff07;
    color: black;
    width: 100%;
    height: 5rem;
    padding: 0.5rem 1rem;
`;

export const PromoButtonContainer = styled.div`
    width: 20rem;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
`;

export const PromoButton = styled.button`
    width: 60%;
    height: 3.5rem;
    border: none;
    font-size: 1.2rem;
    font-weight: 500;
    border-radius: 10px;
    color: black;
    background-color: white;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;

export const PromoSctionQrCodeContainer = styled.div<{
    isPrm: boolean;
}>`
    padding: ${(props) =>
        props.isPrm ? "0rem 2rem 0rem 2rem" : "4rem 2rem 3rem 2rem"};
    height: ${(props) => (props.isPrm ? "42rem" : "68rem")};
    width: 100%;
    gap: ${(props) => (props.isPrm ? "0px" : "2rem")};
`;

// Gifts Section CSS
const computeDisplayHeight = (props: {
    isGiftOnly: boolean;
    isPrm: boolean;
}) => {
    if (props.isPrm && props.isGiftOnly) return "28rem";
    if (props.isPrm) return "20rem";
    if (props.isGiftOnly) return "51rem";
    return "10rem";
};

export const GiftsContainer = styled.div<{
    isGiftOnly: boolean;
    isPrm: boolean;
}>`
    min-height: ${(props) => computeDisplayHeight(props)};
    padding: 0.8 1rem 0 1rem;
`;
export const GitsTitle = styled.span`
    font-size: var(--font-size-title);
    font-weight: 500;
    margin: 0 1rem;
`;
export const AvailableBalance = styled.span`
    all: unset;
    font-size: 1.5rem;
    color: #4c5155;
    font-weight: normal;
`;

export const CardButton = {
    width: "90%",
    height: "3rem",
    border: "none",
    fontSize: "1rem",
    borderRadius: "0px",
};

export const selectedCardButton = {
    width: "90%",
    height: "3.5rem",
    border: "none",
    fontSize: "1rem",
    borderRadius: "0px",
};

export const EmptyCodePromoContainer = styled.div`
    margin-top: 1rem;
    font-size: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
`;

export const PromoCodeCardContainer = styled.div`
    box-sizing: border-box;
    background-color: var(--global-color);
    border-radius: 10px;
    padding: 0 8px;
    height: 100px;
    display: grid;
    grid-template-columns: 80% 20%;
    align-items: center;
`;

export const PromoCodeOnlyCardContainer = styled.div`
    box-sizing: border-box;
    background-color: var(--global-color);
    border-radius: 10px;
    padding: 0 5px 0 15px;
    width: 60.5rem;
    height: 100px;
    display: flex;
    flex-flow: column wrap;
    align-items: center;
`;

// Rewards Section
export const RewardsContainer = styled.div<{ isPrm: boolean }>`
    height: ${(props) => (props.isPrm ? "34rem" : "75rem")};
    display: grid;
    grid-template-rows: 5rem auto;
    width: 100%;
`;
export const RewardTitle = styled.span<{
    isPrm: boolean;
}>`
    font-size: var(--font-size-title);
    font-weight: 500;
    margin: 1rem;
    text-align: ${(props) => (props.isPrm ? "center" : "start")};
`;

export const PrmImgSwitcher = styled.img`
    height: 80px;
    width: 80px;
    box-shadow: 0px 3px 6px #00000080;
    border-radius: 15px;
`;

export const PrmLoyaltyActionsListContainer = styled.div<{
    isPrmGift: boolean;
}>`
    z-index: 99999;
    position: fixed;
    right: 69px;
    bottom: ${(props) => (props.isPrmGift ? "1433px" : "1205px")};
    background-color: #b5b2b2;
    width: 20.5rem;
    height: 16rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 10px 10px 0px 10px;
    gap: 0.5rem;
    padding: 5px;
`;

export const PrmMenuIcon = styled.div<{ isActionListOpen: boolean }>`
    margin-left: 0.5rem;
    background-color: ${(props) =>
        props.isActionListOpen ? "#b5b2b2" : "white"};
    border-radius: ${(props) =>
        props.isActionListOpen ? "0px 0px 10px 10px" : "0px"};
`;
